<div class="impostos-selecao">
  <div class="controle-linha">
    <button type="button" class="link-toggle" (click)="togglePainel()">
      {{ painelAberto ? 'Ocultar' : 'Selecionar impostos' }}
      <mat-icon>{{ painelAberto ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <span class="resumo-texto">{{ resumoLabel }}</span>
  </div>

  @if (semSelecao) {
  <app-alert-card type="warning" class="alerta-sem-selecao">
    Nenhum imposto selecionado — nada será impresso nos itens.
  </app-alert-card>
  }

  @if (painelAberto) {
  <div class="painel-impostos">
    <div class="painel-cabecalho">
      <span class="painel-titulo">Impostos impressos nos itens</span>
      <div class="painel-acoes">
        <button type="button" class="acao-marcar-todos" [disabled]="disabled" (click)="marcarTodos()">Marcar todos</button>
        <button type="button" class="acao-limpar" [disabled]="disabled" (click)="limpar()">Limpar</button>
      </div>
    </div>

    <div class="painel-corpo">
      @for (grupo of grupos; track grupo.titulo) {
      <div class="grupo-coluna">
        <span class="grupo-titulo">{{ grupo.titulo }}</span>
        @for (item of grupo.itens; track item.idTipoImpostoImpressao) {
        <mat-checkbox
          class="grupo-item"
          [checked]="isSelecionado(item.idTipoImpostoImpressao)"
          [disabled]="disabled"
          (change)="onToggleImposto(item.idTipoImpostoImpressao, $event)">
          {{ item.descricao }}
        </mat-checkbox>
        }
      </div>
      }
    </div>
  </div>
  }
</div>
